<div id="myCarousel"  class="carousel slide mb-6" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active" >
      <video
        autoplay
        loop
        muted
        style="width: 100%; background-color: white"
      >
        <source src="../assets/video/unidadMovil.mp4" type="video/mp4">
        Tu navegador no admite el elemento video.
      </video>
    </div>
  </div>
</div>
